import { GetAllPaymentMethodResponseItem } from '@esg/business-setting';
import { GetCustomerDetailResponse } from '@esg/business-crm';
import { Dayjs, getEnv } from '@esg/shared';
import { HttpRequestData, httpUtil } from '@esg/framework';

import { SalePromotionGetDetailResponse } from '@esg/business-management';

import { SaleDetailGetAllResponseItem } from '../sale-detail';
import { GetDetailBranchResponseItem } from '../../../organization/api/branch/getDetailBranch';
import { CancelReasonSale, SaleStatus, UnitEnum } from './getDetailSale';

interface GetDetailSaleBasicRequest extends HttpRequestData {
    readonly pathData: {
        readonly id: string;
    };
}

export interface GetDetailSaleBasicResponse {
    readonly id: string;
    readonly code: string;
    readonly date: Dayjs;
    readonly checkoutAt: Dayjs;
    readonly totalAmount: number;
    readonly tip: number;
    readonly tipUnit: UnitEnum;
    readonly subTotal: number;
    readonly note?: string;
    readonly cancelNote?: string;
    readonly cancelReasonId?: string;
    readonly cancelReason?: CancelReasonSale;
    readonly taxAmount: number;
    readonly subTotalDetail: number;
    readonly paymentMethodSettingId?: string;
    readonly paymentMethodSetting?: GetAllPaymentMethodResponseItem;
    readonly status: SaleStatus;
    readonly customerId?: string;
    readonly customer?: GetCustomerDetailResponse;
    readonly saleDetails?: SaleDetailGetAllResponseItem[];
    readonly isActive: boolean;
    readonly paidFromScheduler?: boolean;
    readonly salePromotions?: SalePromotionGetDetailResponse[];
    readonly branchId?: string;
    readonly branch: GetDetailBranchResponseItem;
}

export const getDetailSaleBasic = httpUtil.createHttpRequestMeta<GetDetailSaleBasicRequest, GetDetailSaleBasicResponse>({
    baseUrl: () => getEnv().MANAGEMENT_SERVER,
    path: '/api/v1/sales/:id/basic',
    method: 'GET'
});